import {
  getAlternateLinks,
  getCanonicalLink,
  getIsMainLiveCDN,
} from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import LandingPagesHeadComp, {
  IProps as ICompProps,
} from '@bridebook/web/app-shared/components/landing/landing-pages-head';

type IProps = Omit<ICompProps, 'canonical' | 'alternate' | 'isMainLiveCDN'>;

const LandingPagesHead = (props: IProps) => {
  const canonical = useSelector(getCanonicalLink);
  const alternate = useSelector(getAlternateLinks);
  const isMainLiveCDN = useSelector(getIsMainLiveCDN);

  return (
    <LandingPagesHeadComp
      {...props}
      canonical={canonical}
      alternate={alternate}
      isMainLiveCDN={isMainLiveCDN}
    />
  );
};

export default LandingPagesHead;
